import React, { useEffect, useState } from "react";
import CrossAttachmentAssessment from "../../Create_Assessment/Attachment/CrossAttachmentAssessment";
import ZoomableImage from "../../../../Components/zoomablePic";
import { Box, Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../../Components/QuestionEditCreate/PdfViewer";
import { IP } from "../../../../internalServer";
// css comes in mcqQuestion from review hw

const McqQuestion = ({
  response,
  questionNumber,
  setResponseAnswers,
  studentResults,
  isAdaptive,
}) => {
  const [isRightAnswer, setIsRightAnswer] = useState(false);
  const [inputValue, setInputValue] = useState({
    remark: "",
    score: 0,
  });
  if (isAdaptive) {
    response = response?.question_response;
  }
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState("");
  const handleClickforpdf = (fileUrl) => {
    setResponseAttach(fileUrl);
    setMideaviewer(true);
  };

  useEffect(() => {
    // if(response.answer.key !== response.question.correct_answers[0].option_key){
    //   setIsRightAnswer(true)
    // }

    if (response && response.answer && response.question) {
      const key = response.answer.key;
      const correctAnswer = response.question.correct_answers;

      if (Array.isArray(correctAnswer) && correctAnswer.length > 0) {
        const isKeyCorrect = correctAnswer.some(
          (answer) => answer.option_key === key
        );
        if (!isKeyCorrect) {
          setIsRightAnswer(true);
        } else {
          setIsRightAnswer(false);
        }
      } else {
      }
    } else {
    }
  }, [response]);

  const { remark, score } = inputValue;

  const checkCorrectAnswer = (key) => {
    if (response?.question?.correct_answers?.length > 0) {
      return response?.question?.correct_answers?.find(
        (answer) => answer.option_key === key
      );
    }
  };

  const checkStudentAnswer = (option_key) => {
    if (response?.answer) {
      return response?.answer?.key === option_key;
    }
  };

  const matchResultWithResponse = () => {
    let result = studentResults.find(
      (result) => result?.question_response?.id === response?.id
    );
    return result;
  };

  useEffect(() => {
    !studentResults?.length > 0 &&
      setInputValue({
        remark: response?.result?.remark,
        score: response?.result?.score ? response?.result?.score : "0",
      });
    const resultInitialization = () => {
      setResponseAnswers((prevState) =>
        prevState.map((responseData) =>
          responseData.id === response.id
            ? {
              ...responseData,
              result: {
                ...responseData.result,
                questionResponse: response.id,
                correctScore: response?.question?.correct_score,
                score: response?.question?.correct_answers?.some(
                  (correctAnswer) =>
                    checkStudentAnswer(correctAnswer?.option_key)
                )
                  ? response?.question?.correct_score
                  : "0",
              },
            }
            : responseData
        )
      );
    };
    (!response?.result?.questionResponse || !response?.result?.correctScore) &&
      !studentResults?.length > 0 &&
      resultInitialization();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const handleSubmitRemark = (e) => {
    setResponseAnswers((prevState) =>
      prevState.map((responseData) =>
        responseData.id === response.id
          ? {
            ...responseData,
            result: { ...responseData.result, remark: e.target.value },
          }
          : responseData
      )
    );
  };

  const handleSubmitScore = (e) => {
    const newScore = e.target.value !== "" ? Number(e.target.value) : 0;
    setResponseAnswers((prevState) =>
      prevState.map((responseData) =>
        responseData.id === response.id
          ? {
            ...responseData,
            result: { ...responseData.result, score: newScore },
          }
          : responseData
      )
    );
  };

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 1,
        p: 2.5,
        borderRadius: 3,
        border: "1px solid #f1c27d",
        background: "#fff",
      }}
    >
      {/* QUESTION HEADER */}
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Typography fontWeight={700} color="#8D4B28">
          Q{questionNumber + 1}.
        </Typography>

        <Typography fontWeight={600} lineHeight={1.6}>
          {response?.question?.title?.split("\n").map((line, index) => (
            <span key={index}>
              {index !== 0 && <br />}
              {line}
            </span>
          ))}
        </Typography>
      </Stack>

      {/* QUESTION ATTACHMENTS */}
      {response?.question?.attachments?.length > 0 && (
        <Stack direction="row" spacing={2} mt={2} ml={4}>
          {response.question.attachments.map((attachment, index) => {
            const ext = attachment?.split(".").pop()?.toLowerCase();
            const isImage = ["jpg", "jpeg", "png"].includes(ext);

            return (
              <Box key={index} maxWidth={220}>
                {isImage ? (
                  <ZoomableImage src={attachment} />
                ) : (
                  <CrossAttachmentAssessment attachment={attachment} />
                )}
              </Box>
            );
          })}
        </Stack>
      )}

      <Divider sx={{ my: 2 }} />

      {/* OPTIONS */}
      <Stack spacing={1.5} ml={4}>
        {response?.question?.options?.map((option, index) => {
          const isCorrect = checkCorrectAnswer(option?.key);
          const isStudent = checkStudentAnswer(option?.key);

          return (
            <Box
              key={index}
              sx={{
                p: 1.5,
                borderRadius: 2,
                border: "1px solid",
                borderColor: isCorrect
                  ? "#16a34a"
                  : isStudent
                    ? "#dc2626"
                    : "#e5e7eb",
                backgroundColor: isCorrect
                  ? "#ecfdf5"
                  : isStudent
                    ? "#fef2f2"
                    : "#ffffff",
              }}
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <input
                  type="checkbox"
                  readOnly
                  checked={isCorrect || isStudent}
                  className={
                    isCorrect
                      ? "response_green_checkbox"
                      : "response_red_checkbox"
                  }
                />

                <Typography fontWeight={500}>
                  {option?.key}. {option?.value}
                </Typography>

                {isCorrect && (
                  <Chip
                    label="Correct Answer"
                    size="small"
                    sx={{
                      ml: "auto",
                      backgroundColor: "#16a34a",
                      color: "#fff",
                    }}
                  />
                )}

                {isStudent && (
                  <Chip
                    label="Student Answer"
                    size="small"
                    sx={{
                      ml: "auto",
                      backgroundColor: isCorrect ? "#16a34a" : "#dc2626",
                      color: "#fff",
                    }}
                  />
                )}
              </Stack>

              {/* OPTION ATTACHMENT */}
              {option.attachment && (() => {
                const fileUrl =
                  typeof option.attachment === "string"
                    ? option.attachment
                    : option.attachment?.url;

                if (!fileUrl) return null;

                const fileType = fileUrl.split(".").pop().toLowerCase();
                const isImage = ["jpg", "jpeg", "png"].includes(fileType);
                const isVideo = ["mp4", "mov"].includes(fileType);
                const isPdf = fileType === "pdf";

                const fileIcon =
                  iconData?.find((i) => i.extension === fileType)?.icon ||
                  "/images/file_icon.png";

                const fullUrl = fileUrl.startsWith("http")
                  ? fileUrl
                  : `${IP}${fileUrl}`;

                return (
                  <div className="d-flex flex-row align-items-center me-3">
                    {/* ===== Preview ===== */}
                    {isImage ? (
                      <Box mt={1} ml={4}>
                        <ZoomableImage src={option.attachment} />
                      </Box>
                    ) : isVideo ? (
                      <video
                        src={fullUrl}
                        style={{
                          width: "60px",
                          height: "50px",
                          borderRadius: "6px",
                          marginBottom: "5px",
                        }}
                        controls
                      />
                    ) : isPdf ? (
                      <div
                        onClick={() => handleClickforpdf(fileUrl)}
                        style={{
                          width: "100px",
                          height: "50px",
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={fileIcon}
                          alt="pdf"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <div className="hw_default_attach_name">
                          <span>
                            {option.attachment?.replace(/^[^_]*_/, "")}
                          </span>
                        </div>
                      </div>
                    ) : (
                      <a
                        href={`https://docs.google.com/gview?url=${encodeURIComponent(
                          fullUrl
                        )}&embedded=true`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          style={{
                            width: "100px",
                            height: "50px",
                            background: "#f5f5f5",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={fileIcon}
                            alt="file"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </div>
                      </a>
                    )}
                  </div>
                );
              })()}
            </Box>
          );
        })}
      </Stack>

      {/* ANSWER STATUS */}
      <Box mt={2} ml={4}>
        {response?.answer?.key === " " ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <img src="/images/wrong_icon.svg" alt="" />
            <Typography fontWeight={600} color="#dc2626">
              Student Not Answered
            </Typography>
          </Stack>
        ) : (
          isRightAnswer && (
            <Stack direction="row" spacing={1} alignItems="center">
              <img src="/images/wrong_icon.svg" alt="" />
              <Typography fontWeight={600} color="#dc2626">
                Wrong Answer
              </Typography>
            </Stack>
          )
        )}
      </Box>

      {/* TEACHER COMMENT & MARKS */}
      {!isAdaptive && (
        <Box mt={3}>
          <Typography fontWeight={600} mb={1}>
            Teacher Comment
          </Typography>

          <textarea
            onBlur={handleSubmitRemark}
            onChange={(e) =>
              setInputValue((prev) => ({ ...prev, remark: e.target.value }))
            }
            readOnly={studentResults?.length > 0}
            maxLength={250}
            className="remark_textfield_box_hw"
            value={
              studentResults?.length > 0
                ? matchResultWithResponse()?.comment
                : remark
            }
          />

          <Stack direction="row" spacing={2} mt={2} alignItems="center">
            <Typography>
              Allot marks out of {response?.question?.correct_score}
            </Typography>

            <input
              onBlur={handleSubmitScore}
              readOnly={studentResults?.length > 0}
              value={
                studentResults?.length > 0
                  ? matchResultWithResponse()?.obtained_marks
                  : score
              }
              className="score_box_hw px-2"
              type="text"
            />
          </Stack>

          <Typography fontSize={12} color="red" mt={1}>
            NOTE: You cannot enter more than correct marks
          </Typography>

          {/* CORRECT ANSWER EXPLANATION */}
          {response?.question?.correct_answers?.length > 0 && (
            <Box mt={4}>
              <Typography fontWeight={600} mb={2}>
                Reason for Correct Answer
              </Typography>

              <Stack spacing={2}>
                {response.question.correct_answers.map((cAnswer, index) => (
                  <Paper
                    key={index}
                    elevation={0}
                    sx={{
                      p: 2,
                      borderRadius: 2,
                      border: "1px solid #16a34a",
                      background: "#f0fdf4",
                    }}
                  >
                    <Typography>
                      {cAnswer?.reason_for_answer?.explanation ||
                        cAnswer?.value}
                    </Typography>

                    {cAnswer?.reason_for_answer?.attachment && (
                      <Box mt={1}>
                        <CrossAttachmentAssessment
                          attachment={cAnswer.reason_for_answer.attachment}
                        />
                      </Box>
                    )}
                  </Paper>
                ))}
              </Stack>
            </Box>
          )}
        </Box>
      )}
      {mideaviewer && (
        <PdfViewer
          setMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
    </Paper>
  );
};

export default McqQuestion;
